export default __webpack_public_path__ + "static/media/arrow_back-dark.b61d18a8.svg";